// extracted by mini-css-extract-plugin
module.exports = {"banner":"teach-on-udemy-banner_banner__hHb5r","subtitle":"teach-on-udemy-banner_subtitle__VDy_F","button-container":"teach-on-udemy-banner_button-container__DoHpH"};